import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { IPortalUser } from '../types';

interface AuthState {
  token: string | null;
  user: IPortalUser | null;
  requiresPasswordReset: boolean;
  setAuth: (token: string, user: IPortalUser, requiresPasswordReset: boolean) => void;
  setUser: (user: IPortalUser, requiresPasswordReset: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      requiresPasswordReset: false,
      setAuth: (token, user, requiresPasswordReset) => {
        set({ token, user, requiresPasswordReset });
      },
      setUser: (user, requiresPasswordReset) => {
        set({ user, requiresPasswordReset });
      },
      clearAuth: () => {
        set({ token: null, user: null, requiresPasswordReset: false });
      },
    }),
    {
      name: 'pbf-portal-auth',
      // Only persist the token - user data is always fetched fresh from /me on reload
      partialize: (state) => ({ token: state.token }),
    },
  ),
);
